/* eslint-disable react/prop-types */
import React from 'react';
import CollectionDetails from './CollectionDetails';
import CollectionDeliverySection from './CollectionDeliverySection';
import RescheduleSection from '../../../../common/components/RescheduleSection';
import {
  bookingHasReschedules,
  isLastBookingInviteDraft,
  getLastInvite,
} from '../../../../common/garageHelpers';
import LineItemsSection from './LineItemsSection';
import InviteStatus from './InviteStatus';
import Title from './Title';
import { getIsGarageMembership } from '../../../../../common/garageMembership';
import GarageMembershipTag from '../../../components/GarageMembershipTag';

const getReschedules = (booking) =>
  booking.garageInvites.reduce((acc, invite) => {
    const collectionTimeChanges = invite.proposedChanges.find((pc) => pc.type === 'collection-time');

    if (collectionTimeChanges) {
      acc.push({
        collectionTimeChanges,
        creationDateTime: invite.creationDateTime,
      });
    }

    return acc;
  }, []);

const shouldDisplayReschedules = (booking) =>
  !isLastBookingInviteDraft(booking) && bookingHasReschedules(booking);

const getGarageCollectionDistance = (garageInvite) =>
  parseFloat(garageInvite?.collectionDistance?.toFixed(1)) || '0';

const GarageFocusAllocationCard = ({ booking, laneId }) => {
  const { collectionDateTimeLocal, collectionAddress, customer, collectionDeliveryOption, quote } =
    booking || {};
  const { firstName, lastName } = customer;
  const columnName = laneId;
  const reschedules = getReschedules(booking);
  const lastInvite = getLastInvite(booking);
  const collectionDistance = getGarageCollectionDistance(lastInvite);

  return (
    <a className="allocation-card" target="_blank" href={`/bookings/${booking.bookingId}`} rel="noreferrer">
      <Title firstName={firstName} lastName={lastName} />
      <LineItemsSection lineItems={quote?.lineItems} />
      {getIsGarageMembership(booking) && <GarageMembershipTag />}
      {shouldDisplayReschedules(booking) && <RescheduleSection booking={booking} reschedules={reschedules} />}
      <div className="allocation-card-footer">
        {columnName === 'unallocated' && <InviteStatus lastInvite={lastInvite} />}
        <CollectionDeliverySection
          collectionDeliveryOption={collectionDeliveryOption}
          collectionDistance={collectionDistance}
        />
        <CollectionDetails
          columnName={columnName}
          collectionDateTimeLocal={collectionDateTimeLocal}
          postcode={collectionAddress.postcode}
        />
      </div>
    </a>
  );
};

export default GarageFocusAllocationCard;
